import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getCurrentUser } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('mercawatch_token');
    const storedUser = localStorage.getItem('mercawatch_user');

    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch {
        localStorage.removeItem('mercawatch_user');
      }
    }
    setLoading(false);
  }, []); // localStorage and state setters are stable references; intentionally run once on mount

  const login = useCallback((token, userData) => {
    localStorage.setItem('mercawatch_token', token);
    localStorage.setItem('mercawatch_user', JSON.stringify(userData));
    setUser(userData);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('mercawatch_token');
    localStorage.removeItem('mercawatch_user');
    setUser(null);
  }, []);

  const isAdmin = user?.role === 'admin';
  const isSupervisor = user?.role === 'supervisor';

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin, isSupervisor }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
